const size = {
  XS: '359px',
  S: '400px',
  M: '600px',
  L: '800px',
}

const theme = {
  XS: `(max-width: ${size.XS})`,
  S: `(max-width: ${size.S})`,
  M: `(max-width: ${size.M})`,
  L: `(max-width: ${size.L})`,
}

export default theme